const LOADING_TYPES = {
  WARMING_UP: "warming-up",
  WELCOME: "welcome",
  FILTER_COMPARATION: "filter-comparation",
  BUILDING_SURVEY: "building-survey",
  PREPARING_RESULTS: "preparing-results",
};

export default LOADING_TYPES;
